import { useState, useEffect } from 'react';

const useTypingEffect = (text, speed = 50) => {
  const [typedText, setTypedText] = useState('');

  useEffect(() => {
    if (text) {
      const timer = setTimeout(() => {
        setTypedText(text.substring(0, typedText.length + 1));
      }, speed);
      return () => clearTimeout(timer);
    }
  }, [typedText, text, speed]);

  return typedText;
};

export default useTypingEffect;